import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _typeof from "/app/node_modules/@babel/runtime-corejs2/helpers/typeof";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import "./index.sass";
import wButton from "../../components/W-Button";
export default {
  name: 'W-Modal',
  components: {
    wButton: wButton
  },
  props: {
    customClass: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'SM' // ['SM', 'MD', 'LG', 'FS']

    },
    buttons: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    closeOnSubmit: {
      type: Boolean,
      default: true
    },
    showing: {
      type: Boolean,
      default: false
    },
    persistent: {
      type: Boolean,
      default: false
    },
    thinking: {
      type: Boolean,
      default: false
    },
    disableButtons: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    standAlone: {
      type: Boolean,
      default: false
    }
  },
  promiseResolve: null,
  byRef: false,
  data: function data() {
    return {
      visibleByRef: false,
      lastEventAction: ''
    };
  },
  computed: {
    i18n: function i18n() {
      return this.$t('modal');
    },
    showMe: function showMe() {
      return this.showing || this.visibleByRef;
    },
    computedButtons: function computedButtons() {
      var _this = this;

      var resButtons = this.buttons.map(function (button) {
        if (_typeof(button) === 'object') {
          var key = Object.keys(button)[0];
          var disabled = !!_this.disableButtons.find(function (btn) {
            return btn[key] === true;
          });
          return {
            type: key,
            label: button[key] || _this.$t("modal.".concat(key)),
            disabled: disabled
          };
        }

        if (typeof button === 'string') {
          return {
            type: button,
            label: _this.$t("modal.".concat(button))
          };
        }
      });
      return resButtons;
    }
  },
  methods: {
    emitModalEvent: function emitModalEvent(_ref) {
      var detail = _ref.detail;
      document.dispatchEvent(new CustomEvent('modalEvent', {
        detail: detail
      }));
    },
    isButtonDisabled: function isButtonDisabled() {},
    beforeShow: function beforeShow() {
      this.$emit('before-show');
    },
    handleShow: function handleShow() {
      // on any show action
      this.$emit('show');
    },
    removeModalFromRoute: function removeModalFromRoute(v) {
      if (!v) {
        this.$store.dispatch('queryMirrored/deleteParam', {
          name: 'modal'
        });
      }
    },
    removeIsEditableFromRoute: function removeIsEditableFromRoute(v) {
      if (!v) {
        this.$store.dispatch('queryMirrored/deleteParam', {
          name: 'isEditable'
        });
      }
    },
    start: function start() {
      var _this2 = this;

      // promise-based mode
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this2.$options.byRef = true;

                  _this2.show();

                  _this2.$options.promiseResolve = resolve;

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    show: function show() {
      var byRef = this.$options.byRef;
      if (byRef) this.visibleByRef = true;
    },
    hide: function hide() {
      if (this.$options.byRef) {
        this.visibleByRef = false;
      } else if (!this.standAlone) {
        this.removeModalFromRoute(false);
        this.removeIsEditableFromRoute(false);
      }

      this.$emit('hide');
    },
    handleButtonAction: function handleButtonAction(type) {
      switch (type) {
        case 'cancel':
          // зачем при отмене мы сохраняем введенные данные?
          this.sendResult(type);
          this.hide();
          break;

        default:
          if (this.closeOnSubmit) {
            this.sendResult(type);
            this.hide();
          } else {
            this.sendResult(type);
          }

          break;
      }
    },
    sendResult: function sendResult(action) {
      this.lastEventAction = action;
      var byRef = this.$options.byRef;

      if (byRef) {
        this.$options.promiseResolve(action);
      } else {
        this.$emit('action', {
          action: action
        });
      }
    },
    handleClose: function handleClose() {
      this.$store.dispatch('queryMirrored/deleteParam', {
        name: 'type'
      });

      if (!this.lastEventAction) {
        this.sendResult('cancel');
      }

      this.lastEventAction = '';
      this.$emit('hide');
    }
  }
};